import { TextPassage } from '@petsmart-ui/sparky';
import { AUTOSHIP_CONST } from '@libs/shared-ui';
import AutoShipDrawer from '@app/pdp/components/AutoshipDrawer';
import type { AutoshipSavingsTextType } from './types';

export default function AutoshipSavingsText({
    displayShipmentDate,
    isAvailable,
    isActive,
    autoship,
}: AutoshipSavingsTextType) {
    const getMessage = () => {
        let msg;
        if (!isAvailable) {
            msg = AUTOSHIP_CONST.NOT_AVAIL_MSG;
        } else if (displayShipmentDate) {
            msg = `Add to your next Autoship on ${displayShipmentDate}`;
        } else {
            msg = '';
        }
        return msg;
    };

    return (
        <TextPassage>
            {getMessage()}
            {isActive && isAvailable && !displayShipmentDate && (
                <AutoShipDrawer
                    linkText={AUTOSHIP_CONST.DRAWER_LINK_TEXT}
                    autoship={autoship}
                />
            )}
        </TextPassage>
    );
}
